import { Component, OnInit } from '@angular/core';
import { QuoteService } from '../../services/quotes.service';
import { ResponseQuoteListItem } from '../../types/dai-server/quotes/quote-responses';
import { LoadingComponent } from "@digi-america/shared";
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { UtcToLocalTimePipe } from "../../../../node_modules/@digi-america/shared/src/lib/pipes/utcToLocal.pipe";

@Component({
  selector: 'app-quote-search',
  imports: [LoadingComponent, FormsModule, RouterLink, CommonModule, UtcToLocalTimePipe],
  templateUrl: './quote-search.component.html',
  styleUrl: './quote-search.component.scss',
  standalone: true
})
export class QuoteSearchComponent implements OnInit {
  quotes?: ResponseQuoteListItem[];

  searchText: string = "";

  constructor(private _quotes: QuoteService) { }

  ngOnInit(): void {
    this._quotes.getQuotes().subscribe(quotes => {
      this.quotes = quotes.sort((a, b) => {
        return b.date.localeCompare(a.date)
      });
    });
  }

  getFilteredQuotes(): ResponseQuoteListItem[] {
    const text = this.searchText.toLowerCase();
    return this.quotes?.filter(q => {
      return q.number.toLowerCase().indexOf(text) !== -1 ||
        q.customerName.toLowerCase().indexOf(text) !== -1 ||
        q.salesRepName.toLowerCase().indexOf(text) !== -1;
    }) ?? [];
  }
}
